const labels = {
    LBL_CREATE: 'Create a new',
    LBL_EMPTY_LIST: 'Empty list',
    LBL_MY: 'My',
    LBL_LIST: '$module$',
    LBL_BY: 'by',
    LBL_OR: 'or',
    LBL_RESOLVED: 'Resolved',
    LBL_ADD_COMMENT: 'Comment',
    LBL_TODAY: 'Today',
    LBL_YESTERDAY: 'Yesterday',
    LBL_ATTACHED_FILES: 'Attached File(s)',
    LBL_FILE_SIZE_EXCEEDED: 'File is too big ({{filesize}}MB).\nMax file size: {{maxFilesize}}MB',
    LBL_MAX_FILES_EXCEEDED: 'You cannot upload any more files.',

    LBL_LOGIN_TITLE: 'Client space',
    LBL_USERNAME: 'Email',
    LBL_PASSWORD: 'Password',
    LBL_UNKNOWN: 'Unknown',
    LBL_RESET_PASSWORD_TITLE: 'Password forgotten?',
    LBL_RESET_PASSWORD_TEXT: 'Fill in the form below and we will send you by email the necessary information to access your account.',
    LBL_EMAIL_ADDRESS: 'Email address',
    LBL_GOTO_LOGIN_PAGE: 'Go to the login page',
    LBL_EXPORT: 'Export data',
    LBL_FORGET_ME: 'Delete data',
    LBL_SAVE: 'Save',
    LBL_CONSENTS_MANAGER: 'Consents management',
    LBL_PERSONNEL_CONSENTS_DATA: 'Edit my info',
    LBL_FORGET_ME_CONFIRM: 'Yes, delete my data',
    LBL_CANCEL: 'Cancel',
    LBL_REQUEST_ACCESS_TITLE: "Create account",

    LBL_LOGIN_ERROR: 'Username or password invalid',

    LBL_RESET_PASSWORD_DONE: 'The connection parameters are sent to your email',
    LBL_SAVE_DONE: 'The changes have been made',
    LBL_EXPORT_DONE: "Data export is in progress, you will receive the download link by email",
    LBL_REQUEST_ACCESS_DONE: 'Your request has been taken into account',
    LBL_ARE_YOU_SURE: 'Are you sure ?',
    LBL_FORGET_ME_TEXT: 'All your data will be deleted ! !',
    LBL_DOWNLOAD_IN_PROGRESS: 'Downloading...',
    LBL_PORTAL_ACCESS_REFUSED: 'Access to the portal refused !',
    LBL_EMAIL_IS_NOT_REGISTERED: 'Email is not registered !',
    LBL_SYSTEM_ERROR: 'Operation not permitted',
    LBL_CREDENTIALS_ALREADY_EXIST: 'Email already registered',

    LBL_GDPR_PORTAL: 'GDPR Portal',
    LBL_LOGIN_PAGE: 'Login',
    LBL_PASSWORD_RECOVERY_PAGE: 'Reset password',
    LBL_HOME_PAGE: "Home page",
    LBL_DOWNLOAD_PAGE: 'Download data',
    LBL_REQUEST_ACCESS_PAGE: "Create account to portal",

    LBL_CLOSE_HELPDESK: 'Close ticket',
    LBL_OPEN_HELPDESK: 'Open ticket',
    LBL_COMMENTED_BY: 'commented by',
    LBL_TYPE_A_COMMENT: 'Type a comment...',
    LBL_DROP_FILE_TO_UPLOAD: 'Click here or drop files here to upload',
    LBL_SEND_COMMENT: 'Send',
    LBL_COMMENTS: 'Comments',
    LBL_SUBMIT_TICKET: 'Submit your ticket',
    LBL_YOU: 'you',

    LBL_HELPDESK_OPEN_DATE_DAYS: 'opened $days$d ago',
    LBL_HELPDESK_OPEN_DATE_HOURS: 'opened $hours$h ago',
    LBL_HELPDESK_OPEN_DATE_HOURS_MINUTES: 'opened $hours$h and $minutes$m ago',
    LBL_HELPDESK_OPEN_DATE_MINUTES: 'opened $minutes$m ago',
    LBL_MAIN_BUTTON: 'Ticket',
    LBL_SEARCH_PLACEHOLDER : 'Find tickets, documents or invoices',
    LBL_FILTER_BY: 'Filter by',
    LBL_REPORTER: 'Reporter',
    LBL_HELPDESK_TICKET_NUM: 'Ticket N°',
    LBL_HELPDESK_OPENED_DATE: 'Opened on',
    LBL_HELPDESK_ASSIGNED_TO: 'Assigned to',
    LBL_HELPDESK_HANDLED_BY: 'Handled by',
    LBL_HELPDESK_DESCRIPTION_TITLE: 'Request description',
    LBL_HELPDESK_CREATED_FROM_COMPANY_MEMBER : 'someone at ',
    LBL_HELPDESK_SEND_MESSAGE: 'Send a message to the support',
    LBL_HELPDESK_RESOLVE_ALERT_TITLE: 'Do you want to close this ticket ?',
    LBL_HELPDESK_RESOLVE_ALERT_DESCRIPTION: 'The ticket will be marked as closed and you will no longer be able to send a message regarding this ticket and customer service will consider the request to be processed and completed.',
    LBL_HELPDESK_MARK_AS_RESOLVED: 'MARK AS RESOLVED',

    LBL_GDPR_PAGE_TITLE: 'GDPR - Manage your personal data',
    LBL_GDPR_DOWNLOAD_MY_DATA: 'Download my data',
    LBL_GDPR_DELETE_MY_DATA: 'Delete my data',
    LBL_GDPR_CONTACT_US: 'Contact our dpo',
    LBL_GDPR_CONTACT_NO: 'Contact #',
    LBL_GDPR_CREATION_DATE: 'Creation date',
    LBL_GDPR_CONTACT_ORIGIN: 'Contact origin',
    LBL_GDPR_PORTABILITY_RIGHT: 'Right to data portability',
    LBL_GDPR_GDPR_FORGOTTEN_RIGHT: 'Right to be forgotten',
    LBL_GDPR_MORE_INFO: 'For more information',
    LBL_HELPDESK_TYPE: 'Type',
    LBL_CREATE_A_TICKET: 'Create a ticket',

    LBL_PAID: 'Paid:',
    LBL_DUE: 'Due:',
    LBL_DOWNLOAD: 'Download',
    LBL_LOADING: 'Loading...',

    LBL_MORE: 'More',
    LBL_YES: 'Yes',
    LBL_NO: 'No',

    LBL_QUOTE_TITLE: 'Your quote',
    LBL_QUOTE_DOWNLOAD_PDF: 'Download PDF',
    LBL_QUOTE_OPEN_PDF: 'Open PDF',
    LBL_QUOTE_SEND_FEEDBACK: 'Send feedback',
    LBL_QUOTE_CONTACT: 'Your contact',
    LBL_QUOTE_LAST_UPDATE: 'Last modification',
    LBL_QUOTE_QUOTE_NO: 'Quote #',
    LBL_QUOTE_VALID_TILL: 'Valid until',
    LBL_QUOTE_CREATE_WITH: 'Quote created with',
    LBL_QUOTE_ERROR: "The quote you want to view is not available, it may have been modified or the URL is not valid, please ask the sales representative again. Otherwise try again later." ,
    LBL_INVOICES: 'Invoices',

    LBL_CONTINUE: 'Continue',
    LBL_ONLINE: 'online',
    LBL_ON: 'on',
    LBL_FIRST_NAME: 'First Name',
    LBL_LAST_NAME: 'Last Name',
    LBL_EMAIL: 'Email',
    LBL_CELL_PHONE: 'Mobile Phone',

    // Esign
    LBL_DOCUMENT_WAS_SIGNED: 'This document was signed',
    LBL_USING_THE_PHONE: 'using the phone',
    LBL_ACCEPT_AND_SIGN_QUOTE: 'Accept and Sign the Quote',
    LBL_SIGNATORY_FORM_GUIDE: 'Enter your contact details to proceed with the electronic signature',
}

export default labels
